import type { User } from 'types/user'
import type { UserReducer } from '@disco/state-management/reducers/user'

const isSAMLLogin = (user: User | UserReducer): boolean => {
  return user.business.login_mechanism === 'saml'
}

export const enableUserInvites = (user: User | UserReducer): boolean => {
  if (user.is_support_user) {
    return true
  }

  const enabledSAML = isSAMLLogin(user)
  const canManageInvitations = user?.permissions?.includes(
    'can_manage_invitations',
  )
  return !canManageInvitations || !enabledSAML
}
